var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass:
        "d-inline-flex align-center gc-2 py-1 px-2 rounded bg-gray-40 text--text cursor-pointer",
      attrs: { "data-qa": "lpu_loyalty_program_label" },
      on: {
        click: function ($event) {
          return _setup.emit("click")
        },
      },
    },
    [
      _c("div", [
        _c(
          "div",
          { staticClass: "d-inline-flex align-center text-body-2 gc-1" },
          [
            _vm._v(
              "\n      " +
                _vm._s(_setup.t("Получите", _setup.options)) +
                "\n      "
            ),
            _c("span", { staticClass: "d-inline-flex align-center" }, [
              _c("span", {
                staticClass:
                  "ui-icon-four-pointed-star-fill ui-icon-fz-smaller special--text mr-1",
              }),
              _vm._v(" "),
              _c(
                "span",
                { staticClass: "d-inline-flex text-subtitle-2" },
                [
                  _c(
                    "span",
                    {
                      attrs: {
                        "data-qa": "lpu_loyalty_program_label_min_bonus",
                      },
                    },
                    [_vm._v(_vm._s(_vm.minPercent))]
                  ),
                  _vm._v(" "),
                  _vm.maxPercent
                    ? [
                        _vm._v("\n            -"),
                        _c(
                          "span",
                          {
                            attrs: {
                              "data-qa": "lpu_loyalty_program_label_max_bonus",
                            },
                          },
                          [_vm._v(_vm._s(_vm.maxPercent))]
                        ),
                      ]
                    : _vm._e(),
                  _vm._v("\n          %\n        "),
                ],
                2
              ),
            ]),
            _vm._v(
              "\n      " +
                _vm._s(_setup.t("бонусами", _setup.options)) +
                "\n    "
            ),
          ]
        ),
        _vm._v(" "),
        _vm.welcomeBonusAmount
          ? _c("div", { staticClass: "text-body-2" }, [
              _vm._v(
                "\n      " + _vm._s(_setup.t("и", _setup.options)) + "\n      "
              ),
              _c(
                "span",
                {
                  attrs: {
                    "data-qa": "lpu_loyalty_program_label_welcome_bonus",
                  },
                },
                [_vm._v(_vm._s(_vm.welcomeBonusAmount.toLocaleString()))]
              ),
              _vm._v(
                "\n      " +
                  _vm._s(
                    _setup.t(
                      `${_setup.welcomeBonusAmountText} сразу`,
                      _setup.options
                    )
                  ) +
                  "\n    "
              ),
            ])
          : _vm._e(),
      ]),
      _vm._v(" "),
      _c("span", {
        staticClass:
          "ui-icon-arrow-right ui-icon-fz-smaller icon-secondary--text",
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }